import React from 'react';

import HelpIcon from '@material-ui/icons/Help';
import ReactTooltip from 'react-tooltip';

const InfoConsentForm = () => {

  return ( 
    <div style={{ 
      marginLeft: '20px',
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center'}}>
      <HelpIcon data-for="consent-form"
        style={{color: '#0aafe1'}}
        data-tip="Termo de Consentimento é obrigatório! Por favor preencher os <br>
        dados corretos e anexa-lo antes do envio para análise."
        data-iscapture="true"
      />
      <ReactTooltip
        id="consent-form"
        type="info"
        multiline
        effect="solid"
      />
    </div>
  );
};

export default InfoConsentForm;
